import React, { useEffect, useState } from 'react';
import pb from './lib/pocketbase';
import RichText from './components/RichText';

export default function MentionsLegalesPage() {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchLegalContent();
    }, []);

    const fetchLegalContent = async () => {
        try {
            const records = await pb.collection('legal').getFullList({
                sort: '-created',
                max: 1
            });
            if (records.length > 0) {
                setContent(records[0].content || '');
            }
        } catch (err) {
            console.error("Error fetching legal content:", err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="page-container" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="loader"></div>
            </div>
        );
    }

    return (
        <div className="page-container">
            <section className="section">
                <div className="section-inner" style={{ maxWidth: '900px', margin: '0 auto' }}>

                    <div className="section-header">
                        <h2>Mentions Légales & Confidentialité</h2>
                        <p>Informations juridiques et protection des données.</p>
                    </div>

                    <article className="card" style={{ padding: '2.5rem' }}>
                        {content ? (
                            <RichText content={content} />
                        ) : (
                            <div style={{ textAlign: 'center', py: '3rem', color: 'var(--text-muted)' }}>
                                <p>Le contenu des mentions légales est en cours de mise à jour.</p>
                            </div>
                        )}
                    </article>
                </div>
            </section>
        </div>
    );
}
